export default "__VITE_ASSET__r2K4RWGB__"